/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Attendance of the workshops that started in the last 30 days.
 * @export
 * @interface AttendanceSummary
 */
export interface AttendanceSummary {
    /**
     * 
     * @type {number}
     * @memberof AttendanceSummary
     */
    workshops?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceSummary
     */
    registered?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceSummary
     */
    checked_in?: number;
}

/**
 * Check if a given object implements the AttendanceSummary interface.
 */
export function instanceOfAttendanceSummary(value: object): value is AttendanceSummary {
    return true;
}

export function AttendanceSummaryFromJSON(json: any): AttendanceSummary {
    return AttendanceSummaryFromJSONTyped(json, false);
}

export function AttendanceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'workshops': json['workshops'] == null ? undefined : json['workshops'],
        'registered': json['registered'] == null ? undefined : json['registered'],
        'checked_in': json['checked_in'] == null ? undefined : json['checked_in'],
    };
}

export function AttendanceSummaryToJSON(json: any): AttendanceSummary {
    return AttendanceSummaryToJSONTyped(json, false);
}

export function AttendanceSummaryToJSONTyped(value?: AttendanceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshops': value['workshops'],
        'registered': value['registered'],
        'checked_in': value['checked_in'],
    };
}

